import { render, staticRenderFns } from "./swiper_broadcastList.vue?vue&type=template&id=0bcf2234"
import script from "./swiper_broadcastList.vue?vue&type=script&lang=js"
export * from "./swiper_broadcastList.vue?vue&type=script&lang=js"
import style0 from "./swiper_broadcastList.vue?vue&type=style&index=0&id=0bcf2234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports